<template>
	<div class="order-details bg-white shadow-default py-2 px-4 rounded-default" @click.stop="$emit('click')">
		<div class="flex justify-between mb-2">
			<div class="flex items-center">
				<span>
					<b>
						{{ order.restaurant.restaurantName }}

						<app-details-shortcut
							:route-name="RouteNames.OrderDetails"
							:identifier="encrypt(order['orderID'])"
						>
							#{{ formatOrderId(order['orderID']) }}
						</app-details-shortcut>
					</b>
					-
				</span>
				<app-icon icon="pencil" class="text-warning mx-2" @click="$emit('onEditAddress')" />

				<span class="mr-2"
					><b>{{ order.address }}</b> -
				</span>
				<!--        <span><b>{{ order.lastDateAccepted | time }}</b> - </span>-->
				<span class="badge text-base bg-background text-secondary px-2 mr-2"
					>Total:
					<span class="text-success">{{ $filters.formatCurrency(order.total, order.currency) }}</span></span
				>
				<span class="badge text-base bg-background text-secondary px-2 mr-2"
					>Transport:
					<span class="text-warning">{{
						$filters.formatCurrency(order.transportCost, order.currency)
					}}</span></span
				>
			</div>
			<div class="flex items-center">
				<span class="font-bold">
					Courier:
					<transport-type-icon class="mr-1" :transport-type="order.courierUser['transportType']" />
					{{ order.courierUser.id ? order.courierUser.name : '' }}
				</span>
			</div>
			<div>
				<span class="badge text-lg bg-secondary px-2 mr-2">
					{{ activeStatus }}
				</span>
				<span :class="['badge text-lg', [delay > 0 ? 'bg-error' : 'bg-success']]">
					{{ delay > 0 ? '+' : '' }}{{ delay }}
				</span>
			</div>
		</div>
		<div class="flex justify-between">
			<order-details-status
				v-for="(status, i) in formatOrderDetails"
				:status="status"
				:duration="calcDuration(i)"
				:key="i"
				:index="i + 1"
			/>
		</div>
	</div>
</template>

<script>
	import orderStatuses from '@/constants/mapOrderStatuses';
	import moment from 'moment';
	import AppDetailsShortcut from '@/components/app/AppDetailsShortcut';
	import RouteNames from '@/router/names';
	import OrderDetailsStatus from '@/components/orders/OrderDetailsStatus';
	import AppIcon from '@/components/app/AppIcon';
	import TransportTypeIcon from '@/components/couriers/TransportTypeIcon';
	import OrderService from '@/services/OrderService';
	import UtilityService from '@/services/UtilityService';

	export default {
		name: 'orderDetailsFloatingCard',
		components: {
			TransportTypeIcon,
			AppDetailsShortcut,
			OrderDetailsStatus,
			AppIcon,
		},
		data: () => ({
			RouteNames,
			openUpdateAddressModal: false,
			addresses: [],
			updateAddressLoading: false,
		}),
		props: {
			order: {
				type: Object,
				required: true,
			},
		},
		computed: {
			delay() {
				let ms = moment().diff(moment(this.order.lastDateAccepted));
				let d = moment.duration(ms);
				return d.minutes() - this.order.deliverytime;
			},
			activeStatus() {
				return orderStatuses.find((status) => status.value === this.order.status).label;
			},
			formatOrderDetails() {
				return orderStatuses.map((orderStatus) => {
					return this.order[orderStatus.prop]
						? {
								...orderStatus,
								time: this.order[orderStatus.prop],
								active: orderStatus.value === this.order.status,
						  }
						: orderStatus;
				});
			},
		},
		methods: {
			formatOrderId(id) {
				return OrderService.formatOrderId(id);
			},
			encrypt(id) {
				return UtilityService.encrypt(id);
			},
			calcDuration(index) {
				let orderStatuses = this.formatOrderDetails;
				if (
					!orderStatuses[index + 1] ||
					!(index + 1) ||
					!orderStatuses[index + 1].time ||
					!index ||
					!orderStatuses[index].time
				)
					return '';
				let duration = moment
					.duration(moment(orderStatuses[index + 1].time).diff(moment(orderStatuses[index].time)))
					.minutes();
				return duration.toString();
			},
		},
	};
</script>

<style scoped></style>
